import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="EVA system initialization sequence"
      visualizer="full"
      autoNext={120000}
      terminal={{
        phases: [
          {
            type: 'command',
            content: 'ಠ_ಠ',
          },
        ],
        config: {
          title: 'EVA',
          typingSpeed: 30,
          phaseDelay: 300,
        },
      }}
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
